import Link from 'next/link';
import xw from 'xwind';

import { SHOP_PATH } from '@/common/constants/routes';
import { Container, Section } from '../layout';
import {
  ButtonEmptyList,
  EmptyListWrapper,
  StyledImagePlaceholder,
  Title,
} from './EmptyList.style';

interface EmptyListProps {
  image: string;
  title: string;
}

function EmptyList({ image, title }: EmptyListProps): JSX.Element {
  return (
    <Section css={xw`flex-1 flex flex-col items-center pt-12 pb-16`}>
      <Container>
        <EmptyListWrapper>
          <StyledImagePlaceholder src={`/images/empty-page/${image}`} />
          <Title>{title}</Title>
          <Link href={SHOP_PATH} passHref>
            <ButtonEmptyList type="button">Get started</ButtonEmptyList>
          </Link>
        </EmptyListWrapper>
      </Container>
    </Section>
  );
}

export default EmptyList;
